<p-dialog header="Confirm emails" [(visible)]="activeEmailSelection" (onHide)="clearEmailsForm()">
    <div *ngIf="!sendingReminder">
        <p>Send reminder to:</p>
        <form [formGroup]="emailForm" class="email-form">
            <div formArrayName="emails" class="email-address-container">
                <div *ngFor="let group of emailForm.controls.emails.controls; let i = index" [formGroupName]="i"
                    class="email-checkbox-container">
                    <p-checkbox [binary]="true" formControlName="enabled"></p-checkbox>
                    <span>{{group.get("email")?.value}}</span>
                </div>
            </div>
            <hr>
            <p>
                Email Template
            </p>
            <p>
                Student language: {{studentLanguage?.name}}
            </p>
            <p-dropdown placeholder="SELECT Template" formControlName="template" optionLabel="name" [options]="availableReminderTemplates" appendTo="body"></p-dropdown>
            <hr>
            <div class="paste-pixel-checkbox-container">
                <p-checkbox [binary]="true" formControlName="withPastePixel"></p-checkbox>
                <span>Use Paste Pixel</span>
            </div>
            <p-button label="Send" (onClick)="sendReminderFromDialog()"></p-button>
        </form>
    </div>
    <div *ngIf="sendingReminder">
        <p-progressSpinner></p-progressSpinner>
        <p>Processing...</p>
    </div>
</p-dialog>
<p-dialog header="Reminder Templates" [(visible)]="activeTemplateConfiguration">
    <form class="template-form">
        <div *ngFor="let form of templatesForm; let i = index" [formGroup]="templatesForm[i]" class="template-sub-form">
            <p>
                {{languages[i].name}}
            </p>
            <div formArrayName="templates">
                <div *ngFor="let template of form.controls.templates.controls; let j = index" [formGroupName]="j"
                    class="template-form-container">
                    <p>{{template.value.id}}</p>
                    <div>
                        <p-dropdown placeholder="Undefined" formControlName="template" [options]="templateList[i]"
                        optionLabel="name" [filter]="true" filterBy="name" appendTo="body"></p-dropdown>
                        <p-button icon="pi pi-trash" (onClick)="deleteTemplateForm(i, j)"></p-button>
                    </div>
                </div>
                <p-button label="Add" (onClick)="addTemplateForm(i)"></p-button>
            </div>
        </div>
        <p-button label="Update" (onClick)="updateTemplates()"></p-button>
    </form>
</p-dialog>
<div>
    <h2 class="global-title">Payment reminders</h2>
</div>
<div>
    <p-button label="Set reminder email template" (onClick)="activateTemplateForm()"></p-button>
</div>
<div>
    <p-table selectionMode="single" [value]="reminders">
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Phase</th>
                <th>Amount due</th>
                <th>Days since last request</th>
                <th>Booking</th>
                <th>Action</th>
                <th>Dismiss</th>
                <th>Delete</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-reminder>
            <tr>
                <td>{{reminder.studentName}}</td>
                <td>{{reminder.paymentReminderStatus.name}}</td>
                <td>{{reminder.dueAmount}}</td>
                <td>{{reminder.daysSinceLastRequest}}</td>
                <td>
                    <a routerLink="/management/edit-booking/{{reminder.bookingId}}" target="_blank">
                        go to booking
                    </a>
                </td>
                <td>
                    <p-button label="Send Reminder" (onClick)="prepareReminderSending(reminder)"></p-button>
                </td>
                <td>
                    <p-button label="dismiss" (onClick)="dismiss(reminder)"></p-button>
                </td>
                <td>
                    <p-button label="delete" (onClick)="disable(reminder)" styleClass="p-button-danger"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>